<div class="d-flex justify-content-between m-3" style="height: 50px">
  <div class="actions m-10">
    <button color="primary" mat-stroked-button [disabled]="this.isSaving()" (click)="close()">
      {{ 'payment.close' | translate }}
    </button>
  </div>
</div>
<div class="container">
  <div class="mb-3">
    <h2>{{ 'terms.title' | translate }}</h2>
  </div>

  <div>
    <div *ngIf="this.mainService.terms">
      <!-- TEST -->
      <div [innerHtml]="
          this.mainService.terms.TermsAcceptanceLongDescription | multiLang
        "></div>
    </div>

    <div [formGroup]="form" style="margin-top: 2rem">
      <mat-checkbox color="primary" formControlName="agreeBox" class="mr-2">
        <strong>{{ 'terms.agreeMessage' | translate }}</strong>
      </mat-checkbox>
    </div>

    <button mat-button class="mb-3" color="primary" (click)="submit()"
      [disabled]="this.form.controls.agreeBox.value != true">
      {{ 'terms.submit' | translate }}
    </button>
  </div>
</div>
